// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606150306/js/" + chunkId + "." + {"44":"2e914a9c","225":"bfde712c","481":"74f802e0","486":"445d6e1c","770":"8dda29e2"}[chunkId] + ".0.6080125533683263.chunk.js";
};